/* eslint-disable */

import React, { Component } from 'react';
import { Form, Divider, Tab, Button } from 'semantic-ui-react';

import { validateImageUrl } from '../../utils/image';
import { validateVideoUrl } from '../../utils/video';
import CardTab from './CardTab';
import { hasUpdates } from './CanvasElementComparer';
import buckets from '../../fileUploader/Buckets';
import AssetGallery from '../../components/common/AssetGalleryV2/AssetGallery';
import './ModalForm.css';

class ModalForm extends Component {
  state = {
    fit: 'FitToWidth',
    fitVideo: 'FitToWidth',
    fitCarousel: 'FitToWidth',
    activeIndex: 0,
    componentMessage: '',
    tabs: [],
    nextTab: 2,
    originalCards: [],
    form: {
      id: '',
      radioGroup: 'Photo',
      radioFit: 'FitToWidth',
      radioFitVideo: 'FitToWidth',
      radioFitCarousel: 'FitToWidth',
      photoName: '',
      imageUrl: '',
      imageTargetUrl: '',
      videoName: '',
      videoUrl: '',
      carouselName: '',
      cards: [],
      order: ''
    }
  };

  componentDidMount() {
    this.initializeEdit();
  }

  selectedTab = (event, data) => {
    const index = data.activeIndex;
    this.setState({ activeIndex: index });
  };

  removeCard = (cardId) => {
    const form = this.state.form;
    let cards = form.cards;
    let tabs = this.state.tabs;
    let nextTab = this.state.nextTab;
    const index = cards
      .map((card) => {
        return card.id;
      })
      .indexOf(cardId);
    cards.splice(index, 1);
    tabs.splice(index, 1);
    tabs.map((tab, index) => {
      tab.menuItem = index + 1;
    });

    form.cards = cards;
    this.setState({ form, tabs, nextTab: nextTab - 1 });
    this.selectedTab(null, { activeIndex: 0 });
  };

  addTab = (e) => {
    e.preventDefault();
    let tabs = this.state.tabs;
    let form = this.state.form;
    const nextCard = this.state.nextTab;
    form.cards.push({ cardName: '', cardImageUrl: '', cardTargetUrl: '' });
    this.setState({ form });
    let elem = this.renderTabContent(this.state.nextTab - 1);
    tabs.push({ menuItem: nextCard, pane: { key: nextCard, content: elem } });
    this.setState({ nextTab: this.state.nextTab + 1, tabs });
  };

  renderTabContent = (index) => {
    return (
      <CardTab
        cardNumber={index + 1}
        removeCard={this.removeCard}
        getFbToken={this.props.getFbToken}
        handleCardChange={this.handleCardChange}
        card={this.state.form.cards[index]}
        onSelectAssetCard={this.onSelectAssetCard}
      />
    );
  };

  onSelectAssetCard = (asset, name, cardNumber) => {
    let form = this.state.form;
    let card = form.cards[cardNumber - 1];

    let filename = asset.filename;
    const extension = filename.split('.').slice(-1);
    const guid = asset.guid;

    if (guid) {
      filename = `${guid}.${extension}`;
    }

    const file_url = buckets[window.location.hostname] + filename;
    card[name] = file_url;
    form.cards[cardNumber - 1] = card;
    this.setState({ form });
  };

  updateComponent = () => {
    this.setState({ componentMessage: '' });
    const form = this.state.form;
    let componentToUpdate = {};
    componentToUpdate.id = this.state.form.id;
    componentToUpdate.type = form.radioGroup;
    componentToUpdate.order = form.order;
    let success = true;

    //console.log('form ModalForm', form)

    switch (true) {
      case form.radioGroup === 'Photo':
        if (!validateImageUrl(form.imageUrl)) {
          this.setState({ componentMessage: 'The Image Url is not valid' });
          success = false;
          break;
        }
        componentToUpdate.name = form.photoName;
        componentToUpdate.radioFit = form.radioFit;
        componentToUpdate.url = form.imageUrl;
        componentToUpdate.imageTargetUrl = form.imageTargetUrl;
        break;
      case form.radioGroup === 'Video':
        if (!validateVideoUrl(form.videoUrl)) {
          this.setState({ componentMessage: 'The Video Url is not valid' });
          success = false;
          break;
        }
        componentToUpdate.name = form.videoName;
        componentToUpdate.radioFitVideo = form.radioFitVideo;
        componentToUpdate.url = form.videoUrl;
        break;
      case form.radioGroup === 'Carousel':
        let valid = true;
        form.cards.map((card) => {
          if (!validateImageUrl(card.cardImageUrl)) {
            valid = false;
          }
        });

        if (!valid) {
          this.setState({ componentMessage: 'The Image Url is not valid' });
          success = false;
          break;
        }
        componentToUpdate.name = form.carouselName;
        componentToUpdate.radioFitCarousel = form.radioFitCarousel;
        componentToUpdate.cards = form.cards;
        break;
      default:
        break;
    }

    if (success) {
      const originalElement = JSON.parse(
        JSON.stringify(this.props.componentToEdit)
      );
      originalElement.cards = this.state.originalCards;
      if (hasUpdates(originalElement, componentToUpdate)) {
        this.props.showPreventMessage();
      }

      this.props.updateComponent(componentToUpdate);
    }
  };

  initializeEdit = () => {
    const componentToEdit = this.props.componentToEdit;

    let form = this.state.form;
    form.radioGroup = componentToEdit.type;
    form.id = componentToEdit.id;
    form.order = componentToEdit.order;

    switch (true) {
      case componentToEdit.type === 'Photo':
        form.photoName = componentToEdit.name;
        form.radioFit = componentToEdit.radioFit;
        form.imageUrl = componentToEdit.url;
        form.imageTargetUrl = componentToEdit.imageTargetUrl;
        break;
      case componentToEdit.type === 'Video':
        form.videoName = componentToEdit.name;
        form.radioFitVideo = componentToEdit.radioFitVideo;
        form.videoUrl = componentToEdit.url;
        break;
      case componentToEdit.type === 'Carousel':
        form.carouselName = componentToEdit.name;
        form.radioFitCarousel = componentToEdit.radioFitCarousel;

        let tabs = [];
        let cardNumber = 1;
        componentToEdit.cards.map((card) => {
          form.cards.push(card);
          this.setState({ form });
          let elem = (
            <CardTab
              removeCard={this.removeCard}
              getFbToken={this.props.getFbToken}
              cardNumber={cardNumber}
              handleCardChange={this.handleCardChange}
              card={this.state.form.cards[cardNumber - 1]}
              onSelectAssetCard={this.onSelectAssetCard}
            />
          );
          tabs.push({
            menuItem: cardNumber,
            pane: { key: cardNumber, content: elem }
          });
          cardNumber = cardNumber + 1;
        });

        const originalCards = JSON.parse(JSON.stringify(componentToEdit.cards));
        this.setState({
          tabs,
          nextTab: componentToEdit.cards.length + 1,
          originalCards
        });
        break;
      default:
        break;
    }

    this.setState({ form });
  };

  onSelectAssetModal = (asset, name) => {
    let filename = asset.filename;
    const extension = filename.split('.').slice(-1);
    const guid = asset.guid;

    if (guid) {
      filename = `${guid}.${extension}`;
    }

    const file_url = buckets[window.location.hostname] + filename;
    let form = this.state.form;
    form[name] = file_url;
    this.setState({ form });
  };

  handleFormChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  handleCardChange = (event, { name, value }) => {
    const cardNumber = event.target.id - 1;
    let form = this.state.form;
    let card = form.cards[cardNumber];
    card[name] = value;
    form.cards[cardNumber] = card;
    this.setState({ form });
  };

  selectFit = (event, { name, value }) => {
    this.setState({ fit: value, form: { ...this.state.form, [name]: value } });
  };

  selectFitVideo = (event, { name, value }) => {
    this.setState({
      fitVideo: value,
      form: { ...this.state.form, [name]: value }
    });
  };

  selectFitCarousel = (event, { name, value }) => {
    this.setState({
      fitCarousel: value,
      form: { ...this.state.form, [name]: value }
    });
  };

  render() {
    const {
      photoName,
      imageUrl,
      imageTargetUrl,
      videoName,
      videoUrl,
      carouselName
    } = this.state.form;
    return (
      <div>
        <div className="warning">
          {this.props.type === 'Video'
            ? 'Video size cannot exceed 1GB, and must be .mp4'
            : 'Image size cannot exceed 4mb, and must be PNG, JPG, or JPEG'}
        </div>
        {this.props.type === 'Photo' ? (
          <div>
            <table className="table-image">
              <tr>
                <td className="column-image-fields">
                  <div className="element-types">
                    <label className="label-element-types">Option:</label>
                    <Form.Radio
                      label="Fit To Width"
                      name="radioFit"
                      value="FitToWidth"
                      className="canvas-radio"
                      checked={this.state.form.radioFit === 'FitToWidth'}
                      onChange={this.selectFit}
                    />
                    <Form.Radio
                      label="Fit to Width Tappable"
                      name="radioFit"
                      value="FitToWidthTappable"
                      className="canvas-radio"
                      checked={
                        this.state.form.radioFit === 'FitToWidthTappable'
                      }
                      onChange={this.selectFit}
                    />
                    <Form.Radio
                      label="Fit To Height (Tilt)"
                      name="radioFit"
                      value="FitToHeight"
                      className="canvas-radio"
                      checked={this.state.form.radioFit === 'FitToHeight'}
                      onChange={this.selectFit}
                    />
                  </div>
                  <Divider hidden />
                  <Form.Input
                    className="input-name"
                    placeholder="Photo Name"
                    type="text"
                    name="photoName"
                    value={photoName}
                    onChange={this.handleFormChange}
                  />
                  <div className="asset-gallery-container asset-gallery-container-modal">
                    <AssetGallery
                      getFbToken={this.props.getFbToken}
                      onAssetSelected={(asset) =>
                        this.onSelectAssetModal(asset, 'imageUrl')
                      }
                      assetType="image"
                      previewFileUrl={this.state.form.imageUrl}
                    />
                  </div>
                  <Form.Input
                    className="input-name"
                    placeholder="Target Url"
                    type="text"
                    name="imageTargetUrl"
                    value={imageTargetUrl}
                    onChange={this.handleFormChange}
                  />
                </td>
              </tr>
            </table>
          </div>
        ) : null}
        {this.props.type === 'Video' ? (
          <div>
            <div className="element-types">
              <label className="label-element-types">Option:</label>
              <Form.Radio
                label="Fit To Width"
                name="radioFitVideo"
                value="FitToWidth"
                className="canvas-radio"
                checked={this.state.form.radioFitVideo === 'FitToWidth'}
                onChange={this.selectFitVideo}
              />
              <Form.Radio
                label="Fit To Height (Tilt)"
                name="radioFitVideo"
                value="FitToHeight"
                className="canvas-radio"
                checked={this.state.form.radioFitVideo === 'FitToHeight'}
                onChange={this.selectFitVideo}
              />
            </div>
            <Divider hidden />
            <Form.Input
              className="input-name"
              placeholder="Video Name"
              type="text"
              name="videoName"
              value={videoName}
              onChange={this.handleFormChange}
            />
            <div className="asset-gallery-container asset-gallery-container-modal">
              <AssetGallery
                getFbToken={this.props.getFbToken}
                onAssetSelected={(asset) =>
                  this.onSelectAssetModal(asset, 'videoUrl')
                }
                assetType="video"
                previewFileUrl={this.state.form.videoUrl}
              />
            </div>
          </div>
        ) : null}
        {this.props.type === 'Carousel' ? (
          <div>
            <Form.Input
              className="input-name"
              placeholder="Carousel Name"
              type="text"
              name="carouselName"
              value={carouselName}
              onChange={this.handleFormChange}
            />
            <Divider hidden />
            <Button
              onClick={this.addTab}
              disabled={this.state.nextTab > 10}
              size="small"
              color="blue"
            >
              Add Card
            </Button>
            <Divider hidden />
            <div className="element-types">
              <label className="label-element-types">Option:</label>
              <Form.Radio
                label="Fit To Width"
                name="radioFitCarousel"
                value="FitToWidth"
                className="canvas-radio"
                checked={this.state.form.radioFitCarousel === 'FitToWidth'}
                onChange={this.selectFitCarousel}
              />
              <Form.Radio
                label="Fit To Height (Tilt)"
                name="radioFitCarousel"
                value="FitToHeight"
                className="canvas-radio"
                checked={this.state.form.radioFitCarousel === 'FitToHeight'}
                onChange={this.selectFitCarousel}
              />
            </div>
            <Divider hidden />
            <Tab
              activeIndex={this.state.activeIndex}
              onTabChange={this.selectedTab}
              panes={this.state.tabs}
              renderActiveOnly={false}
            />
            <Divider hidden />
          </div>
        ) : null}
        <div className="update-button">
          <div className="message-modal">{this.state.componentMessage}</div>
          <Button onClick={this.updateComponent} size="small" color="blue">
            Update Component
          </Button>
          <Button onClick={this.props.onCloseForm} size="small" color="blue">
            Close
          </Button>
        </div>
      </div>
    );
  }
}

export default ModalForm;



// WEBPACK FOOTER //
// ./src/screens/Canvas/ModalForm.js